import { useState } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import styled from 'styled-components';
import { Col, Form, Input, AutoComplete } from 'antd';

import useI18n from '../../common/hooks/useI18n';

const InputContainer = styled.div`
  color: ${(props) => props.theme.colors.secondary};
`;

const AutocompleteAddressField: React.FC = () => {
  const [address, setAddress] = useState('');
  const i18n = useI18n();

  return (
    <PlacesAutocomplete
      value={address}
      onChange={(value) => {
        setAddress(value);
      }}
      onSelect={(value) => {
        setAddress(value);
      }}
      searchOptions={{
        componentRestrictions: {
          country: 'es',
        },
      }}
    >
      {({ getInputProps, suggestions }) => {
        const results = suggestions.map((suggestion) => {
          return {
            label: suggestion.description,
            value: suggestion.description,
          };
        });
        return (
          <Col span={24}>
            <InputContainer>
              <Form.Item
                labelCol={{ span: 24 }}
                name="address"
                label={i18n.t('contactForm.address')}
                rules={[{ required: true }]}
              >
                <AutoComplete options={results}>
                  <Input {...getInputProps()} />
                </AutoComplete>
              </Form.Item>
            </InputContainer>
          </Col>
        );
      }}
    </PlacesAutocomplete>
  );
};

export default AutocompleteAddressField;
